export const ACTIONS = {
  USER_DETAILS_SUBMIT: 'USER_DETAILS_SUBMIT',
  BOOKING_DETAILS_SUBMIT: 'BOOKING_DETAILS_SUBMIT',

  SUBMIT_PURCHASE_START: 'SUBMIT_PURCHASE_START',
  SUBMIT_PURCHASE_SUCCESS: 'SUBMIT_PURCHASE_SUCCESS',
  SUBMIT_PURCHASE_FAILURE: 'SUBMIT_PURCHASE_FAILURE',

  CANCEL_BOOKING_START: 'CANCEL_BOOKING_START',
  CANCEL_BOOKING_SUCCESS: 'CANCEL_BOOKING_SUCCESS',
  CANCEL_BOOKING_FAILURE: 'CANCEL_BOOKING_FAILURE',

  GET_SHOP_INFO_START: 'GET_SHOP_INFO_START',
  GET_SHOP_INFO_SUCCESS: 'GET_SHOP_INFO_SUCCESS',
  GET_SHOP_INFO_FAILURE: 'GET_SHOP_INFO_FAILURE',

  GET_EVENT_START: 'GET_EVENT_START',
  GET_EVENT_SUCCESS: 'GET_EVENT_SUCCESS',
  GET_EVENT_FAILURE: 'GET_EVENT_FAILURE',

  GET_EVENT_SLOTS_START: 'GET_EVENT_SLOTS_START',
  GET_EVENT_SLOTS_SUCCESS: 'GET_EVENT_SLOTS_SUCCESS',
  GET_EVENT_SLOTS_FAILURE: 'GET_EVENT_SLOTS_FAILURE',

  GET_SERVICE_SLOT_START: 'GET_SERVICE_SLOT_START',
  GET_SERVICE_SLOT_SUCCESS: 'GET_SERVICE_SLOT_SUCCESS',
  GET_SERVICE_SLOT_FAILURE: 'GET_SERVICE_SLOT_FAILURE',

  SUBMIT_EVENT_BOOKING_START: 'SUBMIT_EVENT_BOOKING_START',
  SUBMIT_EVENT_BOOKING_SUCCESS: 'SUBMIT_EVENT_BOOKING_SUCCESS',
  SUBMIT_EVENT_BOOKING_FAILURE: 'SUBMIT_EVENT_BOOKING_FAILURE',

  SUBMIT_EVENT_WAITLIST_START: 'SUBMIT_EVENT_WAITLIST_START',
  SUBMIT_EVENT_WAITLIST_SUCCESS: 'SUBMIT_EVENT_WAITLIST_SUCCESS',
  SUBMIT_EVENT_WAITLIST_FAILURE: 'SUBMIT_EVENT_WAITLIST_FAILURE',

  GET_ORDER_PRODUCTS_BY_COLLECTIONS_START: 'GET_ORDER_PRODUCTS_BY_COLLECTIONS_START',
  GET_ORDER_PRODUCTS_BY_COLLECTIONS_SUCCESS: 'GET_ORDER_PRODUCTS_BY_COLLECTIONS_SUCCESS',
  GET_ORDER_PRODUCTS_BY_COLLECTIONS_FAILURE: 'GET_ORDER_PRODUCTS_BY_COLLECTIONS_FAILURE',

  CREATE_ORDER_START: 'CREATE_ORDER_START',
  CREATE_ORDER_SUCCESS: 'CREATE_ORDER_SUCCESS',
  CREATE_ORDER_FAILURE: 'CREATE_ORDER_FAILURE',

  GET_ORDER_BY_SESSION_START: 'GET_ORDER_BY_SESSION_START',
  GET_ORDER_BY_SESSION_SUCCESS: 'GET_ORDER_BY_SESSION_SUCCESS',
  GET_ORDER_BY_SESSION_FAILURE: 'GET_ORDER_BY_SESSION_FAILURE',
};
